module.exports = __webpack_public_path__ + "static/img/tendero.022b804f.svg";